"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTabStrip = void 0;
const React = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const styled_components_1 = __importDefault(require("styled-components"));
class ZTabStripComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.initialValue
        };
    }
    render() {
        const { content, onChange, initialValue, ...tabsProps } = this.props;
        const handleChange = (event, newValue) => {
            this.setState({
                value: newValue
            }, () => {
                onChange && onChange(event, newValue);
            });
        };
        const Content = content;
        return (React.createElement(React.Fragment, null,
            React.createElement(core_1.Tabs, Object.assign({ onChange: handleChange, indicatorColor: "primary", textColor: "primary", variant: "scrollable", scrollButtons: "auto" }, tabsProps, { value: this.state.value })),
            this.state.value != undefined ? (React.createElement(Content, { value: this.state.value })) : null));
    }
}
exports.ZTabStrip = styled_components_1.default(ZTabStripComponent) `
   font-family: ${props => props.theme["font-family"]};
   & .k-item {
      background: transparent;
      &:hover {
         background: ${props => props.theme["top-toolbar-top-background-color"]};
         & .k-link {
            color: ${props => props.theme["hover-color"]};
         }
      }
      &:active {
         background: ${props => props.theme["top-toolbar-top-background-color"]};
         & .k-link {
            color: ${props => props.theme["active-color"]};
         }
      }
      & .k-state-selected {
         background: ${props => props.theme["app-link-color"]};
         color: ${props => props.theme["active-text-color"]};
         font-weight: bold;
      }
      & .k-link {
         color: ${props => props.theme["app-link-color"]};
      }
   }

   background: transparent;
   .MuiTabs-indicator {
      background-color: ${props => props.theme["app-link-color"]};
   }
`;
//# sourceMappingURL=ZTabStrip.js.map